import { observable, action, makeAutoObservable, runInAction, toJS, computed } from 'mobx'
import { IHorse, IHorseVisit, horse, Profile, Contact, Files, ShareKey, Orders, Preview, Calendar, CalendarUpdate } from '../api'
import { useLocalObservable } from 'mobx-react';
import { Event } from '../views/Pages/Components/Calendar';
import { getEventById, getEventByName } from '../views/Pages/Records/utils';
import { uuid } from '../libs/utils';
import { event } from '../views/Pages/Records/utils'
import dayjs, { Dayjs } from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { title } from 'process';
dayjs.extend(utc)
dayjs.extend(timezone)

const PAGE_SIZE = 10
type RequestEvent = {
    date: string | number,
    type: number,
    email: string,
    name: string,
    address: string,
    profileId: string,
}
type Actions = {
    id: string;
    action: 'view' | 'delete' | 'edit' | 'add'
}
export class Horses {
    @observable horses: Array<Profile> = []
    @observable visits: Array<IHorseVisit> = []
    @observable profile: Profile | null = null
    @observable contacts: Array<Contact> = []
    @observable files: Array<Files> = []
    currentHorseId = ''
    @observable request: RequestEvent | null = null
    @observable sharingKey = ''
    @observable isEditingMode = true
    @observable usrId: string | null = null
    @observable currentActions: Actions | null = null
    @observable purchasedCapacity: number = 0
    @observable orders: Orders[] = []
    @observable selectedOrderId = 0
    @observable share: ShareKey | null = null
    @observable preview?: Preview
    constructor() {
        makeAutoObservable(this)
    }

    @action fulshProfile() {
        this.profile = null
    }

    @action changeEditeMode(isEdit: boolean) {
        this.isEditingMode = isEdit
    }

    @action visitActionModify(value: Actions) {
        this.currentActions = value
    }

    @action async decreaseProfileCount(value: number) {
        // let res = await horse.updateUserUsedProfile(value)
        // this.purchasedCapacity = value
    }

    @action async list(usrId?: string) {
        if (usrId) {
            let res = await horse.getProfiles(usrId)
            runInAction(() => {
                this.horses = []
                this.horses = res
                this.usrId = usrId
            })
        } else if (this.usrId) {
            let res = await horse.getProfiles(this.usrId)
            runInAction(() => {
                this.horses = []
                this.horses = res
            })
        }




        return this.horses
    }

    @action async add(params: IHorseVisit) {
        let res = await horse.add(params)
        this.currentHorseId = String(params.horse_id)
        runInAction(() => {
            this.get(this.currentHorseId)
        })

        return res
    }
    @action async update(params: IHorseVisit) {
        let res = await horse.update(params)
        runInAction(() => {
            this.get(this.currentHorseId)
        })
        return res
    }

    @action async delete(visitId: string) {
        let res = await horse.delete(visitId)
        runInAction(() => {
            this.get(this.currentHorseId)
        })
        return res
    }

    @action async get(id: string) {
        this.currentHorseId = id
        let res = await horse.getVisits(id)
        console.log(res)
        runInAction(() => {
            this.visits = []
            this.visits = res

        })

        return res
    }

    @action async addProfile(params: Profile) {
        let res = await horse.addProfile(params)
        //this.decreaseProfileCount(this.horses.length - 1)
        return res
    }

    @action async getProfile(id: string) {
        let res = await horse.getProfile(id)
        console.log(res)
        runInAction(() => {
            this.profile = null
            this.profile = res[0]
        })
        return this.profile
    }

    @action async updateProfile(params: Profile) {
        let res = await horse.updateProfile(params)
        params._ID && this.getProfile(params._ID)
        return res
    }

    @action async deleteProfile(id: string) {
        let res = await horse.deleteProfile(id)
        runInAction(() => {
            this.usrId && this.list(this.usrId)
            //this.decreaseProfileCount(this.horses.length + 1)
        })
        return res
    }

    @action async updateAvatar(params: { avatar: string, id?: string }) {
        let res = await horse.updateAvatar(params.avatar, params.id)
        return res
    }

    @action async addContact(params: Contact) {
        let res = await horse.addContact(params)

        return res
    }

    @action async getContact(id: string) {
        let res = await horse.getContacts(id)
        runInAction(() => {
            this.contacts = []
            this.contacts = res
        })
        return this.contacts
    }

    @action async updateContact(params: Contact) {
        let res = await horse.updateContact(params)

        return res
    }

    @observable fileEventType: number = 0

    @action async addFile(params: Files) {
        let res = await horse.addFile(params)

        return res
    }
    @action async getFiles(id: string) {
        let res = await horse.getFile(id)
        runInAction(() => {
            this.files = []
            this.files = res
        })
        return res


    }

    @action async getFilesByCalendId(id: string) {
        let res = await horse.getFileByCalendarId(id)
        runInAction(() => {
            this.files = []
            this.files = res
        })
        return res


    }

    @action async getFilesByVisitId(id: string) {
        let res = await horse.getFileByVisitId(id)
        runInAction(() => {
            this.files = []
            this.files = res
        })
        return res


    }

    @action async delFiles(id: string, profileId: string) {
        let res = await horse.deleteFile(id)
        runInAction(() => {
            this.getFiles(profileId)
        })
        return res
    }

    @action updateRequesEvent(req: RequestEvent) {
        this.request = req
        return
    }

    @action async sendVisitRequest() {

        if (this.request) {
            const niceName = window.reactPress?.user.data.user_nicename
            const uid = window.reactPress?.user.data.ID
            const email = window.reactPress?.user.data.user_email
            console.log(this.request.date)
            let res = await horse.sendMail({
                email: this.request.email,
                event: getEventById({ _ID: this.request.type }),
                address: this.request.address,
                profile_id: this.request.profileId,
                usr_id: uid,
                description: '',
                date: dayjs(this.request.date, 'DD/MM/YYYY').unix(),
                message:
                    `You have a request from ${niceName} for ${this.request.date} for ${this.profile?.paddock_name} from ${email}`
            })
            return res
        }
    }
    @observable shareUpdateLoading = false
    @action async updateSharePage(id: string, config: Array<number | string>) {
        this.shareUpdateLoading = true
        try {
            await horse.updateShareKey(id, config);
            if (this.share) {
                this.share.config = config
            }
            this.shareUpdateLoading = false
        }
        catch (error) {
            this.shareUpdateLoading = false
            return false
        }
    }

    @action async getSharePage(profileId: string) {
        let currentKey = await horse.getShareKey(profileId)

        if (currentKey.length == 0) {
            const key = uuid(6)
            try {
                const data = { sharing_key: key, profile_id: profileId, config: Object.keys(event) } as ShareKey
                const res = await horse.createShareKey(data)
                this.sharingKey = key
                this.share = {
                    _ID: String(res.item_id),
                    profile_id: profileId,
                    sharing_key: key,
                    config: data.config
                }
                return [{ ...data, _ID: res.item_id }]
            }
            catch (error) {
                return false
            }

        } else {
            this.sharingKey = currentKey[0].sharing_key
            this.share = currentKey[0]
            return currentKey
        }



    }

    @action async getShareProfile(key: string) {
        let share = await horse.getProfileIdBySharekey(key)
        return share[0]
    }

    @action async getPreview(key: string) {
        let share = await horse.getPreview(key)
        runInAction(() => {
            this.profile = null
            this.profile = share.profile
            this.preview = share
        })

        return share
    }

    orderLoading = false
    @action async getAvailableHosres(usrId: string) {
        this.orderLoading = true
        let res = await horse.getProfileOrders(usrId)
        this.orders = []
        runInAction(() => {
            this.orders = res.filter(item => item.order_status == 'complete')
                .filter(item => Number(item.expiry_date) * 1000 > Date.now())
                .map(item => {
                    item.available = this.horses.filter(horse => horse.parent_order_id == item.parent_order_id).length
                    return item
                })
                .filter(item => item.quantity >= item.available!)
            this.orderLoading = false
        })



        console.log(toJS(this.orders), res)

        return this.orders
    }

    @action async setSelectedOrderId(id: number, profileId?: string) {
        this.selectedOrderId = id
        if (profileId) {
            let res = await horse.updatePartialProfile({ parent_order_id: id }, profileId)
        }
        // this.usrId && this.getAvailableHosres(this.usrId)
    }

    @computed checkExpire(profileId: string) {// true is valid ,false is expired
        const horse = this.horses.find(item => item._ID == profileId)
        if (horse) {
            const profilesOrder = this.orders.find(order => order.parent_order_id == horse.parent_order_id)
            if (profilesOrder) {
                return Number(profilesOrder?.expiry_date) * 1000 > Date.now()
            } else {
                return false
            }

        } else { return false }
    }

    @observable calendar: Event[] = []
    @observable savedCalendar: Event[] = []
    @observable calendarLoading = false
    @action async getCalendar(pid?: string) {
        const uid = window.reactPress?.user.data.ID
        if (uid) {
            this.calendarLoading = true
            let res = await horse.getCalendar(uid, pid)
            // let contacts: Contact[]
            // let profiles: Profile[] = []
            // for (const item of res) {

            //     contacts = await this.getContact(item.profile_id);
            //     const profile = await this.getProfile(item.profile_id)
            //     profile && profiles.push(profile)
            // }
            this.calendar = res.map(item => {
                // const contact = contacts.find(element => element.event_type = item.event_type)
                // const profileWithCalendar = profiles.find(element => element._ID = item.profile_id)


                return {
                    _ID: item._ID,
                    profileId: item.profile_id,
                    date: dayjs.unix(Number(item.date)),
                    endDate: dayjs.unix(Number(item.end_date)),
                    title: item.event_type != 'Other' ? item.event_type : item.description,
                    description: item.description,
                    notes: item.notes,
                    address: item.address,

                    // phone: contact?.phone,
                    // horseName: profileWithCalendar?.paddock_name,
                    // email: contact?.email
                }
            })
            this.savedCalendar = this.calendar
        } else {
            throw ('Can not get user info')
        }
        this.calendarLoading = false
    }

    @action async getAllEvent(currentPage?: number, isPublished?: boolean, sortField?: string | null, sortOrder?: string) {
        const uid = window.reactPress?.user.data.ID
        this.calendarLoading = true
        let res = isPublished == true ? await horse.getPublishedEvents() : await horse.getAllEvents(currentPage, sortField, sortOrder)

        this.calendar = res.data.map(item => {
            const timeZone = dayjs.tz.guess()


            return {
                ...item,
                _ID: item._ID,
                profileId: item.profile_id,
                date: dayjs.unix(Number(item.date)),
                endDate: dayjs.unix(Number(item.end_date)),
                title: item.event_type != 'Other' ? item.event_type : item.description,
                description: item.description,
                notes: item.notes,
                address: item.address,
                usrName: item.usr_name,
                usrEmail: item.usr_email,
                files: item.files,
                createDate: dayjs.utc(item.cct_created).tz(timeZone).format('DD/MM/YYYY-HH:mm'),
                status: item.status,
                regions: item.regions,
                public_type: item.public_type
            }
        })
        this.savedCalendar = this.calendar
        this.calendarLoading = false
        return res
    }

    @action async getCalendarDetail(profileId: string) {
        let contacts: Contact[]
        let profiles: Profile[] = []
        contacts = await this.getContact(profileId);
        const profile = await this.getProfile(profileId)
        profile && profiles.push(profile)
        const currentIndex = this.calendar.findIndex(item => item.profileId == profileId)

        if (currentIndex != -1) {
            const contact = contacts.find(element => element.event_type = this.calendar[currentIndex].title)
            const profileWithCalendar = profiles.find(element => element._ID = this.calendar[currentIndex].profileId)

            this.calendar[currentIndex] = {
                ...this.calendar[currentIndex],
                phone: contact?.phone,
                horseName: profileWithCalendar?.paddock_name,
                email: contact?.email,
                usrName: contact?.name
            }
            return this.calendar[currentIndex]
        }

    }

    @action async calendarFilterByEventType(event: string, isPublic: boolean = false) {
        this.calendar = this.savedCalendar
        this.calendar = this.calendar.filter(calendar => {
            if (isPublic == true) {
                console.log(calendar.public_type, event)
                return calendar.public_type == event
            } else {
                if (event == 'Other') {
                    return getEventByName({ name: calendar.title }) ? false : true
                } else {
                    return calendar.title == event
                }

            }

        })
    }

    @observable filterConditions = {
        eventType: null,
        region: {
            city: '',
            region: '',
        },
        isPublic: false,
    };

    @action setEventTypeFilter(eventType, isPublic = false) {
        this.filterConditions.eventType = eventType;
        this.filterConditions.isPublic = isPublic;
        console.log(this.filterConditions)
        this.applyFilters();
    }

    @action setRegionFilter(region: { city: string, region: string }) {
        this.filterConditions.region = region;
        console.log(region)
        this.applyFilters();
    }

    @action applyFilters() {
        this.calendar = this.savedCalendar.filter(calendar => {
            let eventFilter = true;
            let regionFilter = true;

            if (this.filterConditions.eventType) {
                if (this.filterConditions.isPublic) {
                    eventFilter = calendar.public_type === this.filterConditions.eventType;
                } else {
                    eventFilter = this.filterConditions.eventType === 'Other'
                        ? !getEventByName({ name: calendar.title })
                        : calendar.title === this.filterConditions.eventType;
                }
            }

            if (calendar.regions) {
                if (this.filterConditions.region.city != '' && this.filterConditions.region.region != '') {
                    regionFilter = calendar.regions === (this.filterConditions.region.city + ' ' + this.filterConditions.region.region)
                } else if (this.filterConditions.region.city != '') {
                    regionFilter = calendar.regions.trim().includes(this.filterConditions.region.city)
                } else if (this.filterConditions.region.region != '') {
                    regionFilter = calendar.regions.trim().includes(this.filterConditions.region.region)
                }

                //regionFilter = calendar.regions.trim() === this.filterConditions.region;
                //console.log(calendar.regions.trim(), this.filterConditions.region)

            }

            return eventFilter && regionFilter;
        });
    }

    @action removeEventTypeFilter() {
        this.filterConditions.eventType = null;
        this.filterConditions.isPublic = false;
        this.applyFilters();
    }

    @action removeRegionFilter() {
        this.filterConditions.region.city = '';
        this.filterConditions.region.region = '';
        this.applyFilters();
    }


    @action async addCalendar(params: CalendarUpdate) {
        const uid = window.reactPress?.user.data.ID
        if (uid) {
            this.calendarLoading = true
            let res = await horse.addCalendar(uid, params).loading()
            if (params.calendar_type == 'Public') {
                this.getAllEvent(undefined, true)
            } else {
                this.getCalendar()
            }

            this.calendarLoading = false
            return res
        } else {
            throw ('Can not get user info')
        }

    }

    @action async deleteCalendar(id: string, pid?: string) {
        console.log('delete....')
        await horse.deleteCalendar(id)
        return this.getCalendar(pid)
    }

    @action async changeCalendarStatus(id: number, status: string) {
        const uid = window.reactPress?.user.data.ID

        const res = await horse.changeEventStauts(uid, id, status)
        const event = this.calendar.find(item => String(item._ID) == String(res._id))
        console.log(event)
        event?.usrEmail && await horse.sendEmailNotice({
            email: event?.usrEmail,

            title: 'Event Status Changed',
            message:
                `The event you requested on ${event.createDate} was changed to ${status.toLowerCase()} by administrator `
        })


        if (event) {  // 确保找到了事件
            event.status = res.status;  // 更新状态
        }
        if (status == 'Delete') {
            await horse.deleteCalendar(String(id))
        }


    }

    @observable membershipValid: boolean | null = null;
    @observable checking = true;
    @action async checkMembershipValid() {
        try {
            this.checking = true
            this.membershipValid = await horse.getMembershipValid()
            this.checking = false
            return this.membershipValid
        } catch {
            this.checking = false
        }

    }
    getUserRole() {
        return window.reactPress?.user.caps.administrator
    }
}

const self = new Horses();

export const useHorsesStore = (): Horses => {
    const localStore = useLocalObservable(() => self);
    return localStore;
}
export default self;
